// StacksV2
import React, { useEffect, useState } from "react";
import Header from "./main/header";
import Nav from "./main/nav";
import Footer from "./main/footer";
import axios from "axios";
import dayjs from "dayjs";
import "../App.css";

import * as XLSX from "xlsx";
import { APIBaseURL } from "../Config";
import Swal from "sweetalert2";
import { formatToDateTime } from "./main/formatToDateTime";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from 'react-router-dom';

export default function StacksV2({ StackName }) {
  const [Data, setData] = useState([]);
  // const [ReadyStacks, setReadyStacks] = useState(['S1', 'S2', 'S3', 'S4', 'S5', 'S9', 'W1']);
  const [ReadyStacks, setReadyStacks] = useState(
    [
    'C1',
    'C2',
    // 'E1',
    // 'E2',
    // 'E3',
    // 'E4',
    // 'E5',
    // 'H1',
    'H3',
    'H4',

    'I1',
    'I2',
    'I3',
    'I4', // issue
    'I6',
    'I7',

    // 'M1',
    // 'N1',
    // 'N2',
    // 'N3',
    // 'N4',
    // 'N5',
    // 'N6',
    // 'N7',
    // 'N8',
    // 'P5',
    // 'P6',
    // 'P7',
    // 'PATH',
    // 'R1',

    
    // 'R2',
    
    'S1',
    'S2',
    'S3',
    'S4',
    'S5',
    'S9',
    'W1'
    ]
  );

  const [loading, setLoading] = useState(null);
  const [TotalSlot, setTotalSlot] = useState(null);




  const navigate = useNavigate();
  const location = useLocation();

  // const handleClick = (data) => {
  //   alert((JSON.stringify(data)))
  //   const params = new URLSearchParams(location.search);
  //   params.set('name', data.name);
  //   navigate(`${location.pathname}?${params.toString()}`);
  // };

  const GetData = async () => {
    setLoading(true);
    let url = `${APIBaseURL}/get/yard/stacks`;

    try {
      const response = await axios.get(url);
      if (response.data && response.data.status == "success") {
        setData(response.data.data);
      } else {
        setData([]);
        Swal.fire({
          icon: "Info",
          text: `Something Want Wrong..! `,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error in Data Fetch: ${error.message}`,
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    GetData();
  }, []);



  useEffect(() => {
    if (!Data || !Array.isArray(Data)) return;

    const total = Data.reduce((acc, data) => {
      if (
        data.stack_lvl &&
        data.row_start != null &&
        data.row_end != null &&
        data.col_start != null &&
        data.col_end != null
      ) {
        const rows = data.row_end - data.row_start + 1;
        const cols = data.col_end - data.col_start + 1;
        const slots = rows * cols * data.stack_lvl;
        return acc + slots;
      }
      return acc;
    }, 0);

    setTotalSlot(total);
  }, [Data]); // make sure this runs when dataList is updated

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      {/* <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container"> */}
      {/* <Header /> */}
      {/* d */}

      <div className="container mt-4">
        {/* <Nav /> */}
        <div className="w-100">
          <div className="w-100">
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }} className="mt-2">
              <h3 className="text-primary mb-0">Stacks 1</h3>
              {StackName != '1' ?
                <a href="#" className="btn btn-outline-danger btn-sm">Full Map</a>
                : ''}
            </div>

            <div className="row">
              <div className="card">
                <div className="card-body px-1">
                  <div className="table-responsive text-nowrap">
                    
                     <hr />
                    <table className="table table-hover table-striped">
                      <thead>
                        <tr className="table-primary">
                          {/* <td>S.No.</td> */}
                          <td>Stack</td>
                          <td>Row</td>
                          {/* <td>Col</td> */}
                          {/* <td>Height</td>
                          <td>Total Stowage (20ft)</td>
                          <td>Total Stowage (40ft)</td> */}
                          <td>Action</td>
                        </tr>
                      </thead>

                      {/* {Array.isArray(containersData) &&
                          containersData.length > 0 ? ( */}
                      <tbody>
                        {/* {Data?.map((data, i) => { */}
                        {Data?.filter(data => ReadyStacks.includes(data.name)).map((data, i) => (
                          // return (
                          <tr key={i} style={StackName === data.name ? { backgroundColor: '#d3d3d3' } : {}}>
                            {/* <td>
                              <span>{i + 1}</span>
                            </td> */}
                            <td>
                              <span>{data.name}</span>
                            </td>
                            <td>
                              <span>{data.row_start}-{data.row_end}</span>
                            </td>
                            {/* <td>
                              <span>{data.col_start}-{data.col_end}</span>
                            </td> */}
                            {/* <td>
                                  <span>{data.stack_lvl ?? 'N/A'}</span>
                                </td>
                                <td>
                                  <span>
                                    {data.stack_lvl
                                      ? `${(data.row_end - data.row_start + 1) * (data.col_end - data.col_start + 1) * data.stack_lvl}`
                                      : 'N/A'
                                    }
                                  </span>
                                </td>
                                <td>
                                  <span>
                                    {data.stack_lvl
                                      ? `${((data.row_end - data.row_start + 1) * (data.col_end - data.col_start + 1) * data.stack_lvl) / 2}`
                                      : 'N/A'}
                                  </span>
                                </td> */}
                            <td>
                              {/* {StackName} */}
                              {!StackName ?
                                <a href={`/stackView/${data.name}`}
                                  className="btn btn-label-primary btn-sm mx-1"
                                >
                                  <i className="ri-map-pin-line ri-22px"></i>
                                </a>
                                :
                                <a href={`#name=${data.name}`}
                                  className="btn btn-label-primary btn-sm mx-1"
                                >
                                  <i className="ri-map-pin-line ri-22px"></i>
                                </a>
                              }
                            </td>
                          </tr>
                          // );
                          // })}
                        ))}
                      </tbody>
                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>

          <Footer />
          <div className="content-backdrop fade" />
        </div>
      </div>

      {/* </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div> */}
    </>
  );
}
